export default "__VITE_ASSET__fc85d539__"